import _ from 'lodash';

import { navigation } from '../utils';

/**
 * Get experiments values from url string
 * NOTE, that experiment's name should starts from "specs.wmp." to be taken query parameters.
 * For example: https://gcp.wixmp.com?specs.wmp.StunningExp=true
 */
export const getExperimentsFromUrl = () => {
  const params = navigation.location.getQueryParameters();

  return _.reduce(
    params,
    (acc, value, key) => {
      if (/specs\.wmp.+/.test(key)) {
        acc[key] = value;
      }

      return acc;
    },
    {},
  );
};
